import * as React from 'react';
import {
  trackStartVideo,
  trackQuarterWasShown,
  trackHalfWasShown,
  trackThreeQuartersWasShown,
  trackFinishVideo,
} from './tracking';

import * as styles from './styles.css';

interface IVideo {
  videoSrc: string;
  posterSrc: string;
}

export const Video: React.FC<IVideo> = ({ videoSrc, posterSrc }) => {
  const [duration, setDuration] = React.useState<number>(1);
  const [time, setTime] = React.useState<number>(0);
  const [videoHasStarted, setVideoHasStarted] = React.useState<boolean>(false);

  React.useEffect(() => {
    const progress = Math.ceil((time / duration) * 100);

    if (progress === 25) {
      trackQuarterWasShown();

      return;
    }

    if (progress === 50) {
      trackHalfWasShown();

      return;
    }

    /* istanbul ignore next */
    if (progress === 75) {
      trackThreeQuartersWasShown();

      return;
    }
  }, [Math.ceil((time / duration) * 100) % 25 === 0]);

  const handlePlay = () => {
    if (!videoHasStarted) {
      trackStartVideo();
      setVideoHasStarted(true);
    }
  };

  const onLoadedMetadata = (e: React.ChangeEvent<HTMLVideoElement>) => {
    setDuration(Math.ceil(e.target.duration));
  };

  const onTimeUpdate = (e: React.ChangeEvent<HTMLVideoElement>) => {
    setTime(Math.ceil(e.target.currentTime));
  };

  return (
    <video
      onLoadedMetadata={onLoadedMetadata}
      onPlay={handlePlay}
      onEnded={trackFinishVideo}
      onTimeUpdate={onTimeUpdate}
      controls
      poster={posterSrc}
      className={styles['video']}
    >
      <source src={videoSrc} />
    </video>
  );
};
